module.exports = __webpack_public_path__ + "media/img/pages/career-starter/collection/2026_de-9b8e26be69207dad4112d7e0dc399458.jpg";